module.exports = __webpack_public_path__ + "static/fonts/DingTalk_JinBuTi_Regular.f059c1c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DingTalk_JinBuTi_Regular.ttf
// module id = m2yC
// module chunks = 66